import { Route, Routes } from "react-router-dom";

import AdminProtectedRoute from "./AdminProtectedRoute";
import {
  Home,
  Login,
  ListUsers,
  ListPosts,
  ListApplications,
  // ListNotifications,
  QuickSearchConfig,
  CreatePost,
  Programmes,
  ViewApplication,
  Calendar,
  ListTemplates,
  ViewTemplate,
  Ambassadors,
  Referrals,
  AiAdvisor,
  AiUsage,
  AiCompleteness,
  AiConfig,
  AiConversations,
  ReviewInbox,
  ChangeReview,
  CrawlerHealth,
  CatalogCoverage,
  UserReports,
} from "../dashboard";
import NoPage from "../dashboard/NoPage";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AdminProtectedRoute>
            <Home />
          </AdminProtectedRoute>
        }
      />
      <Route path="login" element={<Login />} />
      <Route
        path="review"
        element={
          <AdminProtectedRoute>
            <ReviewInbox />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="review/:id"
        element={
          <AdminProtectedRoute>
            <ChangeReview />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="crawler"
        element={
          <AdminProtectedRoute>
            <CrawlerHealth />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="coverage"
        element={
          <AdminProtectedRoute>
            <CatalogCoverage />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="reports"
        element={
          <AdminProtectedRoute>
            <UserReports />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="ai-advisor"
        element={
          <AdminProtectedRoute>
            <AiAdvisor />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="ai-usage"
        element={
          <AdminProtectedRoute>
            <AiUsage />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="ai-completeness"
        element={
          <AdminProtectedRoute>
            <AiCompleteness />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="ai-config"
        element={
          <AdminProtectedRoute>
            <AiConfig />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="ai-conversations"
        element={
          <AdminProtectedRoute>
            <AiConversations />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="users"
        element={
          <AdminProtectedRoute>
            <ListUsers />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="article"
        element={
          <AdminProtectedRoute>
            <ListPosts category="article" />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="article/*"
        element={
          <AdminProtectedRoute>
            <CreatePost category="article" parentPath="/article" />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="school"
        element={
          <AdminProtectedRoute>
            <ListPosts category="school" />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="school/:id/programmes"
        element={
          <AdminProtectedRoute>
            <Programmes />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="school/:id"
        element={
          <AdminProtectedRoute>
            <CreatePost category="school" parentPath="/school" />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="scholarship"
        element={
          <AdminProtectedRoute>
            <ListPosts category="scholarship" />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="scholarship/*"
        element={
          <AdminProtectedRoute>
            <CreatePost category="scholarship" parentPath="/scholarship" />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="country"
        element={
          <AdminProtectedRoute>
            <ListPosts category="country" />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="country/*"
        element={
          <AdminProtectedRoute>
            <CreatePost category="country" parentPath="/country" />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="applications"
        element={
          <AdminProtectedRoute>
            <ListApplications />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="applications/:id"
        element={
          <AdminProtectedRoute>
            <ViewApplication />
          </AdminProtectedRoute>
        }
      />
      {/* <Route
        path="notifications"
        element={
          <AdminProtectedRoute>
            <ListNotifications />
          </AdminProtectedRoute>
        }
      /> */}
      <Route
        path="quick-search"
        element={
          <AdminProtectedRoute>
            <QuickSearchConfig />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="calendar"
        element={
          <AdminProtectedRoute>
            <Calendar />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="templates"
        element={
          <AdminProtectedRoute>
            <ListTemplates />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="templates/:id"
        element={
          <AdminProtectedRoute>
            <ViewTemplate />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="ambassadors"
        element={
          <AdminProtectedRoute>
            <Ambassadors />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="referrals"
        element={
          <AdminProtectedRoute>
            <Referrals />
          </AdminProtectedRoute>
        }
      />
      <Route path="*" element={<NoPage homeUrl="/" />} />
    </Routes>
  );
};

export default AdminRoutes;
